export const getScrollLeftPx = (element: Element) => {
  const { scrollTop, scrollHeight, clientHeight } = element;
  return scrollHeight - (scrollTop + clientHeight);
};
